export default __webpack_public_path__ + "static/media/snake.659a95fb.jpeg";